import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

/*
 ListSection: Standard container for list views (Actions, Budgets, Categories, etc.)
 Props:
  - title: string (section title) - optional, if not provided, only shows actions/filters
  - actions: ReactNode (left-aligned header actions area: buttons, etc.)
  - filters: ReactNode (right-aligned header filters area)
  - children: body content (list, filters, footer, etc.)
  - headerSx / bodySx / paperSx: style overrides
  - elevation: MUI Paper elevation (default 2)
*/

const ListSection = ({
  title,
  actions = null,
  filters = null,
  children,
  headerSx = {},
  bodySx = {},
  paperSx = {},
  elevation = 2,
  titleProps = {}
}) => {
  return (
    <Paper elevation={elevation} sx={{ p: 0, borderRadius: 3, width: '100%', maxWidth: '100%', mb: 4, ...paperSx }}>
      <Box sx={{
        px: 2,
        pt: 1.5,
        pb: 1.5,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        bgcolor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        ...headerSx
      }}>
        {/* Left side: title (if provided) or actions */}
        {title && !filters ? (
          <>
            <Typography variant="h6" fontWeight="bold" sx={{ m: 0 }} {...titleProps}>
              {title}
            </Typography>
            {actions && (
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center', justifyContent: 'flex-end' }}>
                {actions}
              </Box>
            )}
          </>
        ) : (
          <>
            {/* Buttons on left */}
            {actions && (
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center', flexShrink: 0 }}>
                {actions}
              </Box>
            )}
            {/* Filters on right */}
            {filters && (
              <Box sx={{ flex: 1, minWidth: 0, position: 'relative' }}>
                {filters}
              </Box>
            )}
          </>
        )}
      </Box>
      {!filters && <Divider />}
      <Box sx={{ mb: 2, px: 2, pt: 0, pb: 3, ...bodySx }}>
        {children}
      </Box>
    </Paper>
  );
};

export default ListSection;
